import { render } from "./RestaurantView.vue?vue&type=template&id=0e224c5f"
import script from "./RestaurantView.vue?vue&type=script&lang=js"
export * from "./RestaurantView.vue?vue&type=script&lang=js"

import "./RestaurantView.vue?vue&type=style&index=0&id=0e224c5f&lang=css"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__